import { useRef, useState } from 'react'
import { useTheme } from 'next-themes'
import { useRipple } from '@/hooks/useRipple'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'

import HelpModal from '@/components/LayoutApp/HeaderBar/HelpButton/HelpModal'

const HelpButton = () => {
  const { showVariantHeaderBar } = useDeliveryAppContext()

  const [isOpen, setIsOpen] = useState(false)

  const { resolvedTheme } = useTheme()

  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <button
        ref={ref}
        className={`hover:opacity-80  w-10 h-10 p-2 overflow-hidden rounded-full ${
          showVariantHeaderBar ? '' : 'absolute top-[-8px] right-[-8px]'
        }`}
        onClick={() => setIsOpen(true)}
      >
        {isOpen ? (
          <HelpSvgFill
            fill={resolvedTheme === 'dark' ? '#e0e0e0' : '#323e48'}
          />
        ) : (
          <HelpSvgEmpty />
        )}
      </button>
      {isOpen && <HelpModal isOpen={isOpen} closeModal={closeModal} />}
    </>
  )
}

const HelpSvgFill = ({ fill = '#6b7280' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
      <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 400c-18 0-32-14-32-32s13.1-32 32-32c17.1 0 32 14 32 32S273.1 400 256 400zM325.1 258L280 286V288c0 13-11 24-24 24S232 301 232 288V272c0-8 4-16 12-21l57-34C308 213 312 206 312 198C312 186 301.1 176 289.1 176h-51.1C225.1 176 216 186 216 198c0 13-11 24-24 24s-24-11-24-24C168 159 199 128 237.1 128h51.1C329 128 360 159 360 198C360 222 347 245 325.1 258z" />
    </svg>
  )
}

const HelpSvgEmpty = ({ fill = '#6b7280' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill={fill}>
      <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM256 336c-18 0-32 14-32 32s13.1 32 32 32c17.1 0 32-14 32-32S273.1 336 256 336zM289.1 128h-51.1C199 128 168 159 168 198c0 13 11 24 24 24s24-11 24-24C216 186 225.1 176 237.1 176h51.1C301.1 176 312 186 312 198c0 8-4 14.1-11 18.1L244 251C236 256 232 264 232 272V288c0 13 11 24 24 24S280 301 280 288V286l45.1-28c21-13 34-36 34-60C360 159 329 128 289.1 128z" />
    </svg>
  )
}

export default HelpButton
